import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { IonIcon } from '@ionic/angular/standalone';
import { addIcons } from 'ionicons';
import { checkmarkCircle, checkmarkCircleOutline } from 'ionicons/icons';

@Component({
  selector: 'app-dialog',
  templateUrl: './dialog.component.html',
  imports: [IonIcon],
  // eslint-disable-next-line @angular-eslint/prefer-on-push-component-change-detection -- v22 migration pinned pre-existing zone-CD behavior; OnPush adoption is a separate effort
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./dialog.component.scss'],
})
export class DialogComponent {
  @Input() title: string | undefined;
  @Input() message: string | undefined;
  @Input() titleIcon: string | undefined;
  @Input() celebrating: boolean | undefined;
  @Input() variant: 'default' | 'success' | 'error' | undefined;

  constructor() {
    addIcons({ checkmarkCircle, checkmarkCircleOutline });
  }
}
